<div class="main-container">
  <div class="profile-card" *ngIf="personelServiceDone">
    <div class="profile-area">

<!-- Personel kartı: kimlik + İletişim / Görev / İzin bölümleri; tema vurgusunda (--kabuk-vurgu) -->
<!-- DKM-5104 Cedric: eski hâli (personel yoksa kırmızı "kayıt yok" bloğu çiziliyordu)
<div class="personel-wrapper pk" *ngIf="PersonelInfo?.personelKod && PersonelInfo?.personelTurKod !== 0; else notPersonel">
-->
<!-- DKM-5104: kart her zaman çizilir; personel yoksa boş ve pasif (.pasif) -->
<div class="personel-wrapper pk" [class.pasif]="!personelVar">
  <div class="pk-ust"></div>
  <div class="pk-kimlik">
    <img *ngIf="profilePicture; else harfAvatar" [src]="profilePicture" alt="Profil Resmi" class="pk-foto" />
    <!-- DKM-5104 Cedric: eski hâli
    <ng-template #harfAvatar><div class="pk-foto pk-harf">{{ basHarfler }}</div></ng-template>
    -->
    <ng-template #harfAvatar><div *ngIf="personelVar; else siluet" class="pk-foto pk-harf">{{ basHarfler }}</div></ng-template>
    <!-- DKM-5104: personel yoksa boş gri insan silüeti -->
    <ng-template #siluet><div class="pk-foto pk-siluet" title="Personel kaydı yok"><i class="fa-solid fa-user"></i></div></ng-template>
    <div class="pk-ad">
      <h3>{{ PersonelInfo?.ad }} {{ PersonelInfo?.soyad }}</h3>
      <div class="pk-unvan">{{ PersonelInfo?.personelTurAd }}<ng-container *ngIf="PersonelInfo?.kadroBirimAd"> · {{ PersonelInfo?.kadroBirimAd }}</ng-container></div>
      <div class="pk-unvan" *ngIf="!personelVar">Kullanıcının personel kaydı yok</div>
      <div class="pk-rozetler">
        <span class="pk-rozet"><i class="fa-solid fa-id-badge"></i>Sicil {{ PersonelInfo?.kurumSicilNo || '—' }}</span>
        <span class="pk-rozet gri" *ngIf="PersonelInfo?.dogumTarih"><i class="fa-solid fa-cake-candles"></i>{{ PersonelInfo?.dogumTarih | date: 'dd.MM.yyyy' }}</span>
      </div>
    </div>
  </div>

  <ng-template #alan let-ikon="ikon" let-etiket="etiket" let-deger="deger" let-tam="tam">
    <div class="pk-alan" [class.tam]="tam">
      <i class="fa-solid {{ ikon }}"></i>
      <!-- DKM-5104 Cedric: eski hâli
      <div><small>{{ etiket }}</small><b [class.yok]="!deger">{{ deger || 'Girilmemiş' }}</b></div>
      -->
      <div><small>{{ etiket }}</small><b [class.yok]="!deger">{{ deger || (personelVar ? 'Girilmemiş' : '—') }}</b></div>
    </div>
  </ng-template>

  <div class="pk-bolum">
    <div class="pk-baslik">İletişim</div>
    <div class="pk-alanlar">
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-mobile-screen', etiket: 'Cep telefonu', deger: PersonelInfo?.gsmTelefon }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-phone', etiket: 'Dahili', deger: PersonelInfo?.dahiliTelefon }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-envelope', etiket: 'E-posta', deger: PersonelInfo?.eMail }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-shield-halved', etiket: 'KEP adresi', deger: PersonelInfo?.kepPosta }"></ng-container>
    </div>
  </div>

  <div class="pk-bolum">
    <div class="pk-baslik">Görev</div>
    <div class="pk-alanlar">
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-building', etiket: 'Kadro birimi', deger: PersonelInfo?.kadroBirimAd, tam: true }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-briefcase', etiket: 'Görev birimi', deger: PersonelInfo?.gorevBirimAd, tam: true }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-right-to-bracket', etiket: 'İlk giriş', deger: (PersonelInfo?.ilkGirisTarih | date: 'dd.MM.yyyy') }"></ng-container>
      <ng-container *ngTemplateOutlet="alan; context: { ikon: 'fa-fingerprint', etiket: 'TCKN', deger: maskeliTckn }"></ng-container>
    </div>
  </div>

  <!-- DKM-5023: Memur → bu yıl + önceki yıl, diğerleri → tüm yıllar (vIkaPersonelIzinHakedis) -->
  <div class="pk-bolum">
    <div class="pk-baslik">İzin</div>
    <div class="pk-izin">
      <span class="pk-soluk" *ngIf="izinOzeti === undefined">Yükleniyor…</span>
      <!-- DKM-5104 Cedric: eski hâli
      <span class="pk-soluk" *ngIf="izinOzeti === null">İzin bilgisi alınamadı</span>
      -->
      <span class="pk-soluk" *ngIf="izinOzeti === null && personelVar">İzin bilgisi alınamadı</span>
      <span class="pk-soluk" *ngIf="!personelVar">—</span>
      <ng-container *ngIf="izinOzeti">
        <!-- DKM-5023 (dtokgoz 28.09): kalan eksiyse "X gün fazla kullanıldı" -->
        <div class="pk-izin-ust" [class.fazla]="izinOzeti.kalan < 0">
          <b>{{ izinOzeti.kalan >= 0 ? izinOzeti.kalan : -izinOzeti.kalan }}</b>
          <span>{{ izinOzeti.kalan >= 0 ? 'gün kalan' : 'gün fazla kullanıldı' }} · {{ izinOzeti.kapsam }}</span>
        </div>
        <div class="pk-cubuk" [class.fazla]="izinOzeti.kalan < 0"><div [style.width.%]="izinYuzde"></div></div>
        <div class="pk-izin-alt"><span>Hak edilen {{ izinOzeti.hakEdilen }}</span><span>Kullanılan {{ izinOzeti.kullanilan }}</span></div>
      </ng-container>
    </div>
  </div>

  <!-- dtokgoz 02.10: "İzin Belgesi İste" yerine "İzinlerim" → IkaPersonelIzinlerimForm -->
  <div class="pk-eylem">
    <!-- DKM-5104 Cedric: eski hâli
    <button type="button" class="pk-btn ana" (click)="openIzinlerim()"><i class="fa-solid fa-calendar-check"></i>İzinlerim</button>
    <button type="button" class="pk-btn ikinci" (click)="openBordro()"><i class="fa-solid fa-file-invoice-dollar"></i>Bordrolarım</button>
    -->
    <button type="button" class="pk-btn ana" [disabled]="!personelVar" (click)="openIzinlerim()"><i class="fa-solid fa-calendar-check"></i>İzinlerim</button>
    <button type="button" class="pk-btn ikinci" [disabled]="!personelVar" (click)="openBordro()"><i class="fa-solid fa-file-invoice-dollar"></i>Bordrolarım</button>
  </div>
</div>

<!-- DKM-5104 Cedric: eski hâli (artık kullanılmıyor; kart personel yokken de çiziliyor)
<ng-template #notPersonel>
  <div class="personel-card not-found">
    <img src="assets/none-profile.png" alt="Profil Resmi" class="personel-avatar" />
    <p class="not-text">Kullanıcının personel kaydı yoktur.</p>
  </div>
</ng-template>
-->
    </div>

    <!-- <div class="leave-info" style="pointer-events: none; opacity: 0.5;">
      <div class="leave-title">İzin Bilgilerim</div>
      <div class="leave-details">
        <div class="leave-progress">
          <div class="leave-used" [style.width.%]="30">
            <span>{{ 3 }} Gün</span>
          </div>
          <div class="leave-remaining" [style.width.%]="70">
            <span>{{ 7 }} Gün</span>
          </div>
        </div>
        <div>
          <button class="leave-form">İzin Talep Formu</button>
        </div>
      </div>
    </div> -->
    
    <!-- DKM-5104 Cedric: eski hâli (personel yoksa kutular ve rehber hiç gelmiyordu)
    <div class="sidebar" *ngIf="PersonelInfo?.personelKod && PersonelInfo?.personelTurKod !== 0; else notPersonel2">
    -->
    <div class="sidebar">
      <ng-container *ngFor="let item of sideBarItems; let i = index">
    <div class="sidebar-item" >
      <!-- Analiz Merkezi eski hâli: [ngClass]="{ 'non-card': i === 3 }" (Destek Taleplerim) -->
      <!-- 18.10.2026: Destek Taleplerim etkin (→ /HLP/HlpTaleplerim); eski hâli:
        [ngClass]="{ 'non-card': item.value === 'Destek' || (item.value === 'AnalizMerkezi' && !(analizMerkeziYetkili$ | async)) }" -->
      <div *ngIf="!item.bos" class="card"
        [ngClass]="{ 'non-card': item.value === 'AnalizMerkezi' && !(analizMerkeziYetkili$ | async) }"
        (click)="clickSideBarItems(item)">
        <!-- Ana ekran yenileme (02.10.2026): eski hâli
        <div class="icon">{{ item.icon }}</div>
        -->
        <i class="icon fa-solid {{ item.fa }}"></i>
        <div class="text">{{ item.text }} <span *ngIf="item.count > 0">(<span class="count">{{ item.count }}</span>)</span></div>
      </div>
      <!-- Şimdilik boş yer -->
      <div *ngIf="item.bos" class="card bos-card" aria-hidden="true"></div>
    </div>

    <!-- Analiz Merkezi eski hâli: i === 5 (6 kart) -->
    <div *ngIf="i === sideBarItems.length - 1" class="grid-divider"></div>
  </ng-container>
  <!-- Telefon Rehberi: tek satır, fotoğraflı (GetResim_Request, görünen satırlar), ad/birim/dahili/telefon araması -->
  <div class="rehber">
    <div class="r-ust">
      <h3><i class="fa-solid fa-address-book"></i>Telefon Rehberi</h3>
      <span class="r-sayi">{{ aramaMetni || seciliBirim ? suzulmus.length + ' sonuç' : rehber.length + ' kişi' }}</span>
      <label class="r-ara">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input #rehberAraKutu type="text" placeholder="Ad, birim ya da dahili ara…" autocomplete="off"
          [value]="aramaMetni" (input)="rehberAra(rehberAraKutu.value)" />
        <i *ngIf="aramaMetni" class="fa-solid fa-xmark r-temizle" (click)="rehberAra(''); rehberAraKutu.focus()"></i>
      </label>
    </div>
    <div class="r-cipler" *ngIf="birimler.length > 1">
      <button type="button" class="r-cip" [class.secili]="!seciliBirim" (click)="birimSec(null)">Tümü</button>
      <button type="button" class="r-cip" *ngFor="let b of birimler" [class.secili]="b.ad === seciliBirim" [title]="b.ad" (click)="birimSec(b.ad)">
        {{ b.kisa }} <span>{{ b.sayi }}</span>
      </button>
    </div>
    <div class="r-liste" #rehberListe (scroll)="rehberKaydir(rehberListe)">
      <div class="r-kisi" *ngFor="let k of suzulmus; trackBy: kisiKodu">
        <span class="r-av" [style.--h]="k.renk">
          <img *ngIf="fotoAl(k) as foto; else harf" [src]="foto" alt="" (error)="fotoHata(k)" />
          <ng-template #harf>{{ k.harf }}</ng-template>
        </span>
        <span class="r-ad"><ng-container *ngFor="let p of k.adP"><mark *ngIf="p.e; else d1">{{ p.m }}</mark><ng-template #d1>{{ p.m }}</ng-template></ng-container></span>
        <span class="r-birim"><ng-container *ngFor="let p of k.birimP"><mark *ngIf="p.e; else d2">{{ p.m }}</mark><ng-template #d2>{{ p.m }}</ng-template></ng-container></span>
        <span class="r-dahili" [class.yok]="!k.Dahili"><i class="fa-solid fa-phone" *ngIf="k.Dahili"></i><ng-container *ngFor="let p of k.dahiliP"><mark *ngIf="p.e; else d3">{{ p.m }}</mark><ng-template #d3>{{ p.m }}</ng-template></ng-container></span>
        <span class="r-gsm" [class.yok]="!k.TelefonNo">{{ k.TelefonNo || '—' }}</span>
        <button type="button" class="r-kopya" *ngIf="k.Dahili" title="Dahiliyi kopyala" (click)="kopyala(k.Dahili)"><i class="fa-regular fa-copy"></i></button>
      </div>
      <div class="r-bos" *ngIf="rehberYuklendi && !suzulmus.length">Eşleşen kişi yok.</div>
      <div class="r-bos" *ngIf="!rehberYuklendi">Yükleniyor…</div>
    </div>
  </div>
    </div>
    <!-- DKM-5104 Cedric: eski hâli (artık kullanılmıyor)
    <ng-template #notPersonel2>
  <div class="sidebar not-found">
    <img src="assets/none-profile.png" alt="Profil Resmi" class="personel-avatar" />
    <p class="not-text">Kullanıcının personel kaydı yoktur.</p>
  </div>
</ng-template>
    -->
  </div>

  <div class="logo-box">
    <img src="assets/logo-dabnet.png" alt="Logo" class="img" width="200" />
  </div>
</div>